'use es6';

import PortalIdParser from 'PortalIdParser';
import getIn from 'transmute/getIn';
import { LAST_VIEWED, INBOX_ID, VIEW_ID } from '../records/LastViewedInboxes';
export const getLastViewedViewId = (lastViewed, portalId = PortalIdParser.get()) => getIn([LAST_VIEWED, `${portalId}`, VIEW_ID], lastViewed);
export const getLastViewedInboxId = (lastViewed, portalId = PortalIdParser.get()) => getIn([LAST_VIEWED, `${portalId}`, INBOX_ID], lastViewed);